module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-washington-a043679b96f559d1bf3bf1a608edaaba.png";